module.exports = __webpack_public_path__ + "media/application/images/external-services/amazon-logo-a2c45e216ddce409c9fd9ee29c873c35.svg";